<h1 mat-dialog-title> Detalle Rechazo Solicitud </h1> <br/>

<mat-dialog-content>
    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Tipo rechazo: </mat-label>
            
            <input matInput placeholder = "Tipo Rechazo" [(ngModel)] = "data.tipoRechazo" required [disabled] = "true"> 

        </mat-form-field>
    </p>
    
    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Comentario rechazo: </mat-label>
            
            <input matInput placeholder = "Comentario Rechazo" required [disabled] = "true"> 
            <textarea disabled style=" min-width:500px; max-width:100%;min-height:50px;height:100%;width:100%;" rows="5">{{data.comentarioRechazo}}</textarea>

        </mat-form-field>
    </p>

   
</mat-dialog-content>

<div mat-dialog-actions>

    <button mat-button class = "mat-raised-button btn-dark mat-button" (click) = "onCancelarClick()"> 
        <i class = "fa fa-sign-out-alt"> </i> Salir
    </button>
    
</div>